import React, { Component } from 'react';
import './App.css';
import './shared/services/facebookGoogleScripts';
import WebChatContainer from './Components/WebChatContainer';

if (!process.env.REACT_APP_WITH_LOGS) {
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
}

class App extends Component {
    render() {
        return (
            <div className="App">
                <WebChatContainer className="container1" />
            </div>
        );
    }
}

export default App;
